export default "__VITE_ASSET__Dh1kucN6__"